import { render } from "./Proveedores.vue?vue&type=template&id=5cf40e3e&scoped=true"
import script from "./Proveedores.vue?vue&type=script&lang=js"
export * from "./Proveedores.vue?vue&type=script&lang=js"

import "./Proveedores.vue?vue&type=style&index=0&id=5cf40e3e&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Usuario\\filtros_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cf40e3e"]])

export default __exports__